












































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'QuestionReview'
})
export default class QuestionReview extends Vue {
  @Prop() question!: any;
  @Prop() questionNumber!: number;
  @Prop({ default: 0 }) level!: number;

  getAnswerType (value: string) {
    if (value === 'SINGLE_ANSWER') {
      return 'Single Answer'
    } else if (value === 'MULTIPLE_ANSWER') {
      return 'Multiple Answer'
    } else {
      return 'Textual Answer'
    }
  }
}
